import { configureStore } from "@reduxjs/toolkit";
import simpleModeReducer from "../components/querybuilder/simplemode/simpleModeSlice";
import userAssetsReducer from "../features/userAssets/userAssetsSlice";
import settingsReducer from "../features/settings/settingsSlice";
import userReducer from "../features/settings/userSlice";
import themeReducer from "../features/theme/themeSlice";
import analysisReducer from "../features/analysis/analysisSlice";
import authReducer from "../features/auth/authSlice";
import chatbotReducer from "../features/chatbot/chatbotSlice";

export const store = configureStore({
    reducer: {
        simpleMode: simpleModeReducer,
        userAssets: userAssetsReducer,
        settings: settingsReducer,
        user: userReducer,
        theme: themeReducer,
        analysis: analysisReducer,
        auth: authReducer,
        chatbot: chatbotReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});
